//@import dependencies
import { CertificateCategory, ICertificationsStage } from 'app_types/admin/courseScheduling/courseSchedulingEnrollmentTypes'
import React, { CSSProperties, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import DataTableComponent from 'app_components/commons/dataTable'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './modalCertificationStage.scss'
import CourseSchedulingEnrollmentService from 'app_services/admin/courseScheduling/courseSchedulingEnrollmentService'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
import { sleep } from 'app_utils/functions/sleep'

// @ADD Component types


interface IModalCertificationStageProps {
  open: boolean
  title: string,
  message: string
  notes?: string
  handleClose: (data: any) => void
  className?: string
  styles?: CSSProperties
  certifications: ICertificationsStage[],
  category?: CertificateCategory
}

const ModalCertificationStage: React.FC<IModalCertificationStageProps> = (props) => {

  const courseSchedulingEnrollmentService: CourseSchedulingEnrollmentService = new CourseSchedulingEnrollmentService()
  const screenNotificationsUtil: ScreenNotificationsUtil = new ScreenNotificationsUtil()
  const i18nUtil: I18nUtil = new I18nUtil()

  const {
    open,
    handleClose,
    title,
    message,
    certifications,
    notes,
    category
  } = props

  const { t } = useTranslation()
  const [processing, uploadProcessing] = useState<boolean>(false)


  const handleCloseModal = (data: any) => {
    if (processing) return;
    handleClose(data)
  }

  const handleSubmit = async () => {
    uploadProcessing(true)

    const certificateQueueIds = certifications.reduce((accum: string[], element) => {
      accum.push(element.certificationQueueId)
      return accum;
    }, [])

    screenNotificationsUtil.fireProcessing()

    const response = await courseSchedulingEnrollmentService.certificationForceProcess({
      certificateQueueIds,
      category,
      async: true
    }, {
      showError: false
    })
    if (response) {

      screenNotificationsUtil.fireToast(
        {
          message: `${i18nUtil.getTranslate('modules.modal_certification_stage.process_success')}`,
        },
        {
          position: 'center',
        },
      )
      await sleep(3000)
      handleClose({status: true})
    }
  }

  return(
    <div className=''>
      <Modal
        show={open}
        onHide={() => handleCloseModal({ status: false })}
        className='modal_certification_stage-component'
        size={'lg'}
      >
        <Modal.Header>
          <Modal.Title>
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            {notes ? (
              <div className="alert alert-info">
                {notes}
              </div>
            ): null}
            {certifications.length > 0 ? (
              <>
                {message}
                <DataTableComponent
                  data={certifications}
                  headerKeys={[
                    `Code`,
                    `Estado`,
                    `Documento de identidad`,
                    `Participante`,
                    `Tipo de certificado`,
                    `Consecutivo`
                  ]}
                  keys={[
                    'certificationCode',
                    'certificationStatus',
                    'userDocNumber',
                    'userFullName',
                    'certificationType',
                    'certificateConsecutive'
                  ]}
                  onModal={null}
                />
                <div className='buttons-group mb-3'>
                  <div className='text-center'>
                    <button
                      className='btn btn-light'
                      type='button'
                      onClick={() => handleCloseModal({ status: false })}
                      disabled={processing}
                    >
                      {processing && (<><span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>&nbsp;&nbsp;</>)}
                      {t('modules.modal_certification_stage.cancel_button')}
                    </button>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <button
                      className='btn btn-secondary'
                      type='button'
                      onClick={handleSubmit}
                      disabled={processing}
                    >
                      {processing && (<><span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>&nbsp;&nbsp;</>)}
                      {t('modules.modal_certification_stage.process_button')}
                    </button>
                  </div>
                </div>
              </>
            ): (
              <div className="alert alert-warning">
                {t('modules.modal_certification_stage.no_certificates_selected')}
              </div>
            )}
          </>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ModalCertificationStage
